const FLEX_CACHE_DB_NAME = "flex.indexed-db.flex-cache";
const FLEX_CACHE_PREVIOUS_DB_NAME = "flex-cache";
const FLEX_CACHE_DB_VERSION = 2;
const FLEX_CACHE_DB_STORE_NAME = "react-query-persist";
const FLEX_CACHE_DB_METADATA_STORE_NAME = "metadata";

export { FLEX_CACHE_DB_METADATA_STORE_NAME, FLEX_CACHE_DB_NAME, FLEX_CACHE_DB_STORE_NAME, FLEX_CACHE_DB_VERSION, FLEX_CACHE_PREVIOUS_DB_NAME };
//# sourceMappingURL=meta.mjs.map
